module.exports = __webpack_public_path__ + "img/Rear_seats.7481cff9.jpg";